import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {NotFoundComponent} from './modules/general/not-found/not-found.component';
import {LoginComponent} from './modules/general/login/login.component';
import {ChoiceSiteComponent} from "./modules/general/choice-site/choice-site.component";

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./layaout/layaout.module').then((m) => m.LayaoutModule)
  },
  {
    path: 'signin',
    component: LoginComponent,
  },
  { path: 'choice-your-site', component: ChoiceSiteComponent },
  {
    path: '**',
    component: NotFoundComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
